import React from 'react';

const Error = () => {
  return (
    <div className="error">Page not found.</div>
  );
}

export default Error;